export const translateVals = {
  // 1
  sustainabilityPressure: {
    "No sustainability concern": 0.00,
    "Minimal internal discussion": 0.08,
    "Low visibility in roadmap": 0.15,
    "Customer pressure noted": 0.25,
    "Basic ESG commitment": 0.35,
    "Carbon mapping started": 0.50,
    "Lifecycle tracking in progress": 0.65,
    "Supply chain alignment": 0.75,
    "Automated emissions tagging": 0.85,
    "Verified ESG reporting": 0.93,
    "Sustainability as core strategy": 1.00
  },

  // 2
  esgCompliance: {
    "No compliance program": 0.00,
    "Manual reporting only": 0.10,
    "Basic ESG policy in place": 0.20,
    "Initial compliance checklist": 0.30,
    "Early-stage CSRD alignment": 0.45,
    "PLM-linked disclosures": 0.55,
    "Audit-ready ESG reporting": 0.65,
    "CSRD workflow in PLM": 0.75,
    "Real-time ESG data exchange": 0.85,
    "AI-supported ESG tracking": 0.93,
    "Proactive ESG governance": 1.00
  },

  // 3
  greenProductInnovation: {
    "No sustainable design": 0.00,
    "Basic material awareness": 0.10,
    "Recyclability considered": 0.20,
    "Lifecycle modeling exists": 0.30,
    "Sustainable design rules applied": 0.45,
    "Eco-design validation via tools": 0.55,
    "End-of-life simulations used": 0.65,
    "Circular design features embedded": 0.75,
    "Digital twin includes sustainability metrics": 0.85,
    "Customer-visible green scoring": 0.93,
    "Green-first product innovation culture": 1.00
  },

  // 4
  supplyChainCircularity: {
    "Linear supply chain": 0.00,
    "End-of-life not considered": 0.10,
    "Basic recycling tracking": 0.20,
    "Recyclability mapped": 0.30,
    "Supplier EOL compliance in place": 0.45,
    "Circularity BOM considered": 0.55,
    "Design-for-remanufacture active": 0.65,
    "Supplier circularity score used": 0.75,
    "Platform circular design tools": 0.85,
    "Digital loop w/ 3rd parties": 0.93,
    "Fully circular PLM integration": 1.00
  },

  // 5
  supplierDependency: {
    "Fully captive production": 0.00,
    "Single supplier dependency": 0.10,
    "Limited dual sourcing": 0.20,
    "Mapped sourcing risks": 0.35,
    "Critical supplier flagged": 0.45,
    "Strategic dual sourcing in place": 0.55,
    "Geopolitical risk evaluated": 0.65,
    "Disruption scenario tested": 0.75,
    "Digital dependency matrix used": 0.85,
    "Supply resilience scores": 0.93,
    "Multi-sourcing PLM enabled": 1.00
  },

  // 6
  collaborationNeed: {
    "No collaboration required": 0.00,
    "Basic file exchange": 0.10,
    "Email-based interaction": 0.20,
    "Part portal used occasionally": 0.30,
    "Cross-department handover exists": 0.45,
    "PLM sharing with key teams": 0.55,
    "Change collaboration visible": 0.65,
    "Active co-creation workflows": 0.75,
    "Supplier team workspace shared": 0.85,
    "Real-time digital co-authoring": 0.93,
    "Global concurrent collaboration": 1.00
  },

  // 7
  geographicSpread: {
    "All operations in 1 location": 0.00,
    "Manufacturing in 2+ locations": 0.10,
    "Engineering in 2 regions": 0.20,
    "Cross-timezone collaboration": 0.35,
    "Offshore teams involved": 0.45,
    "Supplier ecosystem globally spread": 0.55,
    "Tools + data in multiple sites": 0.65,
    "Global release coordination": 0.75,
    "Multi-lingual support required": 0.85,
    "Geo-specific BOM variants exist": 0.93,
    "Real-time global synchronization": 1.00
  },

  // 8
  supplierToolsGap: {
    "Suppliers use same PLM": 0.00,
    "Minor version mismatch": 0.10,
    "Some offline CAD exchange": 0.20,
    "No CAD-neutral formats": 0.30,
    "No change tracking on supplier side": 0.45,
    "No secure portal access": 0.55,
    "Only PDFs shared for parts": 0.65,
    "Delayed BOM updates": 0.75,
    "Multiple tool mismatches": 0.85,
    "Manual data sync with suppliers": 0.93,
    "No PLM-capable suppliers": 1.00
  },

  // 9
  supplierSLAPressure: {
    "No SLAs exist": 0.00,
    "Basic delivery schedule": 0.10,
    "Loose tolerance allowed": 0.20,
    "Design delays tolerated": 0.30,
    "Time penalties apply": 0.45,
    "PLM-based delivery expectations": 0.55,
    "SLA breaches visible": 0.65,
    "Contracted PLM milestones": 0.75,
    "Performance scorecards tracked": 0.85,
    "Service Level AI prediction used": 0.93,
    "SLA-linked PLM automation active": 1.00
  },

  // 10
  partnerEcosystemMaturity: {
    "No partner PLM connectivity": 0.00,
    "Manual handover w/ partners": 0.10,
    "Portal access only": 0.20,
    "Only manufacturing partners digital": 0.30,
    "System integrators onboarded": 0.45,
    "Common data models shared": 0.55,
    "Co-innovation with tech partners": 0.65,
    "Digital fabric across ecosystem": 0.75,
    "Lifecycle transparency shared": 0.85,
    "Multi-PLM connected ecosystem": 0.93,
    "Open innovation via PLM mesh": 1.00
  },

  // 11
  serviceRevenue: {
    "Only physical product revenue": 0.00,
    "Service <5% revenue": 0.10,
    "Spare part sales exist": 0.20,
    "Field service optional": 0.30,
    "Standard warranty processes": 0.45,
    "Service BOM maintained": 0.55,
    "Usage data collected": 0.65,
    "Digital twin extends lifecycle": 0.75,
    "Predictive service revenue": 0.85,
    "Service-as-a-platform": 0.93,
    "Majority revenue from service": 1.00
  },

  // 12
  businessModelShift: {
    "One-time sale model": 0.00,
    "Basic licensing model": 0.10,
    "Hardware + add-ons": 0.20,
    "Bundles with software": 0.30,
    "Support as revenue stream": 0.45,
    "Subscription options exist": 0.55,
    "Upgrades as service": 0.65,
    "Data monetization started": 0.75,
    "Platform ecosystem active": 0.85,
    "Usage-based pricing": 0.93,
    "Fully outcome-based model": 1.00
  },

  // 13
  lifecycleMonetization: {
    "No monetization beyond sale": 0.00,
    "Only spare part sale": 0.10,
    "SLA monetization exists": 0.20,
    "Performance-based support": 0.30,
    "EOL monetization exists": 0.45,
    "Connected service tracked": 0.55,
    "Design-use feedback loop": 0.65,
    "Configuration-based pricing": 0.75,
    "Predictive maintenance monetized": 0.85,
    "Twin-based new value streams": 0.93,
    "Lifecycle-wide monetization": 1.00
  },

  // 14
  digitalThreadMonetization: {
    "No digital thread": 0.00,
    "Change log used manually": 0.10,
    "Design-Test linkage visible": 0.20,
    "Usage data viewed post-facto": 0.30,
    "Some analytics from lifecycle": 0.45,
    "Automated change prediction": 0.55,
    "Part failure analytics linked": 0.65,
    "Service revenue via analytics": 0.75,
    "Digital twin fuels roadmap": 0.85,
    "Monetization strategy formalized": 0.93,
    "Analytics-as-a-business unit": 1.00
  },

  // 15
  ipPortfolioLeverage: {
    "No IP strategy in PLM": 0.00,
    "Patents not linked to design": 0.10,
    "Innovation not tracked in PLM": 0.20,
    "Designs not IP protected": 0.30,
    "Some IP policy exists": 0.45,
    "IP capture workflows exist": 0.55,
    "IP clearance embedded in release": 0.65,
    "IP monetization analytics": 0.75,
    "PLM linked with IP valuation": 0.85,
    "Smart IP protection active": 0.93,
    "Strategic IP-driven product plans": 1.00
  },

  // 16
  programMarginUplift: {
    "No margin tracking in PLM": 0.00,
    "BOM cost only tracked": 0.10,
    "Cost center variance visible": 0.20,
    "Cost-to-design iteration": 0.30,
    "Target costing applied": 0.45,
    "Change-driven cost delta shown": 0.55,
    "Reuse linked to margin": 0.65,
    "Variant costing optimized": 0.75,
    "Real-time cost-margin feedback": 0.85,
    "Margin driver analytics": 0.93,
    "PLM-to-ERP closed loop margin": 1.00
  },

  // 17
  ipCapitalizationReadiness: {
    "No IP assets managed": 0.00,
    "Design = Document only": 0.10,
    "Digital models not reusable": 0.20,
    "IP rights not tracked": 0.30,
    "Versioning but not valuation": 0.45,
    "IP inventor workflow mapped": 0.55,
    "IP asset tagging in PLM": 0.65,
    "IP lifecycle tracked": 0.75,
    "Capitalization model in place": 0.85,
    "Auditable IP value chain": 0.93,
    "PLM-as-IP Asset Engine": 1.00
  },

  // 18
  mAFrequency: {
    "No M&A activity": 0.00,
    "Infrequent org changes": 0.10,
    "Only legal entity mergers": 0.20,
    "Occasional asset purchases": 0.30,
    "Multiple org shifts past 5 yrs": 0.45,
    "PLM reorg needed once": 0.55,
    "Integration of acquired PLMs": 0.65,
    "Frequent asset-based buys": 0.75,
    "Dynamic org-unit ownership": 0.85,
    "Cross-border integration": 0.93,
    "Continuous acquisition mode": 1.00
  },

  // 19
  localizationDemand: {
    "Single language, single geo": 0.00,
    "Static export market": 0.10,
    "Dual-country distribution": 0.20,
    "Multi-country same design": 0.30,
    "Local rules vary by geo": 0.45,
    "Localized documentation exists": 0.55,
    "Market-specific variants": 0.65,
    "Local cert/test per geo": 0.75,
    "Real-time local requirements": 0.85,
    "Automated localization engine": 0.93,
    "Global-local synchronized PLM": 1.00
  },

  // 20
  technicalDebt: {
    "Modern stack": 0.00,
    "Some legacy CAD formats": 0.10,
    "Partial old workflows": 0.20,
    "Hardcoded release paths": 0.30,
    "Outdated data structures": 0.45,
    "Old versions of PLM": 0.55,
    "PLM customizations blocking upgrade": 0.65,
    "Unowned legacy scripts": 0.75,
    "Zombie integrations": 0.85,
    "High migration blockers": 0.93,
    "Legacy debt halting PLM growth": 1.00
  },

  // 21
  engineeringIPRisk: {
    "Fully secure infra": 0.00,
    "Basic credential control": 0.10,
    "Open folders for vendors": 0.20,
    "No access logs": 0.30,
    "No IP clearance process": 0.45,
    "Limited watermarking": 0.55,
    "Basic export control in PLM": 0.65,
    "No contract/IP traceability": 0.75,
    "Frequent IP exposure risk": 0.85,
    "Critical leak possible": 0.93,
    "Severe uncontrolled IP spread": 1.00
  },

  // 22
  migrationComplexity: {
    "Modern platform, no migration": 0.00,
    "Small system upgrade planned": 0.10,
    "Basic PLM-to-PLM migration": 0.20,
    "Legacy CAD data cleanup needed": 0.30,
    "Siloed departments need merge": 0.45,
    "Process alignment needed": 0.55,
    "Partial rehosting needed": 0.65,
    "Deep schema transformation": 0.75,
    "High interdependency of data": 0.85,
    "Multiple vendor ecosystems": 0.93,
    "Full PLM replatforming needed": 1.00
  },

  // 23
  cybersecurityExposure: {
    "Hardened PLM infra": 0.00,
    "Firewall protected": 0.10,
    "Internal only access": 0.20,
    "Outdated OS risk": 0.30,
    "No threat scans": 0.45,
    "No change audit logs": 0.55,
    "No 2FA for access": 0.65,
    "External users no control": 0.75,
    "PLM open on VPN": 0.85,
    "Known exposure detected": 0.93,
    "Highly vulnerable setup": 1.00
  },

  // 24
  resilienceRequirement: {
    "No resilience mandate": 0.00,
    "Basic RTO expectations": 0.10,
    "Data recovery plan exists": 0.20,
    "Tested failover once": 0.30,
    "BOM duplication risk known": 0.45,
    "Critical product recovery mapped": 0.55,
    "Backup PLM instance exists": 0.65,
    "Geo-distributed architecture": 0.75,
    "Self-healing PLM infra": 0.85,
    "Active-active PLM sync": 0.93,
    "Real-time DR built in": 1.00
  },

  // 25
  revenueResilience: {
    "Revenue fully linear": 0.00,
    "One product = most revenue": 0.10,
    "No recurring revenue": 0.20,
    "Spare/service dependency": 0.30,
    "Multi-program coverage exists": 0.45,
    "Revenue tied to digital services": 0.55,
    "Diversified product revenue": 0.65,
    "Insights → revenue stream": 0.75,
    "Data-driven monetization": 0.85,
    "AI-coordinated resilience": 0.93,
    "PLM-secured revenue spread": 1.00
  },

  // 26
  productComplexity: {
    "Mechanical only, few parts": 0.00,
    "Basic variants": 0.10,
    "Initial ECAD integration": 0.20,
    "MCAD+ECAD synchronized": 0.30,
    "Software in BOM": 0.45,
    "Simulation involved": 0.55,
    "1000+ parts/program": 0.65,
    "Configuration by rules": 0.75,
    "System-of-systems exists": 0.85,
    "Multi-layered, cross-domain": 0.93,
    "Ultra-complex cyber-physical": 1.00
  },

  // 27
  changeFrequency: {
    "Yearly or less": 0.00,
    "Few times/year": 0.10,
    "Quarterly": 0.20,
    "Monthly": 0.30,
    "Biweekly": 0.45,
    "Weekly": 0.55,
    "Multiple/week": 0.65,
    "Daily": 0.75,
    "Multiple/day": 0.85,
    "Near-real-time": 0.93,
    "Continuous Engineering": 1.00
  },

  // 28
  volumeVarietyMix: {
    "Low volume, low variety": 0.00,
    "Low variety, moderate volume": 0.10,
    "Medium volume, few SKUs": 0.20,
    "High variety low volume": 0.30,
    "Mixed-model": 0.45,
    "Batch-variety mismatch": 0.55,
    "Partially configure-to-order": 0.65,
    "Multiple streams → same line": 0.75,
    "High-mix high-volume": 0.85,
    "Every-order unique": 0.93,
    "Mass customization in place": 1.00
  },

  // 29
  cadIntensity: {
    "2D only": 0.00,
    "Basic 3D parts": 0.10,
    "Simple 3D assemblies": 0.20,
    "Structured 3D BoMs": 0.30,
    "Variant CADs for product": 0.45,
    "MCAD+ECAD linking": 0.55,
    "Linked 3D JT visualizations": 0.65,
    "Up-to-date design models": 0.75,
    "Live design-in-context": 0.85,
    "CAD = master source": 0.93,
    "Model-based digital twin": 1.00
  },

  // 30
  lifecycleLength: {
    "1–2 years": 0.00,
    "2–4 years": 0.10,
    "4–6 years": 0.20,
    "6–8 years": 0.30,
    "8–10 years": 0.45,
    "10–12 years": 0.55,
    "12–15 years": 0.65,
    "15–20 years": 0.75,
    "20+ years": 0.85,
    "Over 30 years": 0.93,
    "Indefinite support lifecycle": 1.00
  },

  // 31
  reusePotential: {
    "No reuse": 0.00,
    "Unstructured reuse": 0.10,
    "Excel catalog of reuse": 0.20,
    "Manual part reuse": 0.30,
    "Subassembly reuse evident": 0.45,
    "Library of reuse exists": 0.55,
    "Reuse tracked in PLM": 0.65,
    "Searchable reuse policies": 0.75,
    "Automated reuse suggestions": 0.85,
    "AI reuse assistants": 0.93,
    "Predictive reuse simulation": 1.00
  },

  // 32
  partCount: {
    "Under 10 parts": 0.00,
    "10–50 parts": 0.10,
    "50–100 parts": 0.20,
    "100–500 parts": 0.30,
    "500–1000 parts": 0.45,
    "1k–5k parts": 0.55,
    "5k–10k parts": 0.65,
    "10k–50k parts": 0.75,
    "50k–100k parts": 0.85,
    "100k–500k parts": 0.93,
    "Million+ part configurations": 1.00
  },

  // 33
  productConfigurability: {
    "Single variant": 0.00,
    "Manual variant duplication": 0.10,
    "Multiple variants per part": 0.20,
    "Excel-based variant logic": 0.30,
    "Basic configuration rules": 0.45,
    "Config BOM in PLM": 0.55,
    "Effectivity across configs": 0.65,
    "Options/features controlled": 0.75,
    "Model-based config rules": 0.85,
    "Customer-facing configurators": 0.93,
    "Smart mass-customization": 1.00
  },

  // 34
  portfolioBreadth: {
    "Single product line": 0.00,
    "2–3 products": 0.10,
    "4–6 related products": 0.20,
    "1–2 domains only": 0.30,
    "Cross-domain product range": 0.45,
    "Multiple platforms": 0.55,
    "Geo-specific SKUs": 0.65,
    "Options & variants explode": 0.75,
    "Global portfolio sync needed": 0.85,
    "10+ programs concurrently": 0.93,
    "100+ variants in sync": 1.00
  },
  // 35
  programDuration: {
    "Less than 3 months": 0.00,
    "3–6 months": 0.10,
    "6–12 months": 0.20,
    "1–2 years": 0.30,
    "2–3 years": 0.45,
    "3–5 years": 0.55,
    "5–7 years": 0.65,
    "7–10 years": 0.75,
    "10–15 years": 0.85,
    "15–20 years": 0.93,
    "Over 20 years": 1.00
  },

  // 36
  crossDomainNeed: {
    "Single discipline (e.g., MCAD)": 0.00,
    "Occasional ECAD interface": 0.10,
    "Basic SW artifacts outside PLM": 0.20,
    "Informal x-domain workflows": 0.30,
    "Two domains managed in PLM": 0.45,
    "Three domain data tracked": 0.55,
    "Multidomain coordination exists": 0.65,
    "MBSE collaboration underway": 0.75,
    "Full RFLP + simulation visible": 0.85,
    "Model + cross-domain sync": 0.93,
    "Real-time integrated design": 1.00
  },

  // 37
  sensorizationLevel: {
    "No sensors in product": 0.00,
    "Sensor optional": 0.10,
    "Manual sensor retrofit": 0.20,
    "Basic IoT BOM": 0.30,
    "Sensors for status data": 0.45,
    "Multi-sensor tracking": 0.55,
    "Time-series feedback loop": 0.65,
    "Sensor → analytics workflow": 0.75,
    "Feedback → design loop": 0.85,
    "Sensorized twin connected": 0.93,
    "Product-as-a-data-platform": 1.00
  },

  // 38
  productAsPlatform: {
    "Standalone product": 0.00,
    "Manual variants": 0.10,
    "Design templates reused": 0.20,
    "Shared components across lines": 0.30,
    "Platform architecture modeled": 0.45,
    "Partial PLE reuse": 0.55,
    "Platform BOM & variant logic": 0.65,
    "Feature-driven product lines": 0.75,
    "Product = configurable platform": 0.85,
    "Model-driven product platform": 0.93,
    "Strategic product platforming": 1.00
  },

  // 39
  legacyProcessGap: {
    "Fully digital": 0.00,
    "Minor Excel usage": 0.10,
    "Some approvals via email": 0.20,
    "Legacy workflows active": 0.30,
    "Some outdated ERP links": 0.45,
    "Manual processes outside PLM": 0.55,
    "Disconnected change flows": 0.65,
    "High human intervention": 0.75,
    "Multiple workarounds": 0.85,
    "PLM resistance from users": 0.93,
    "Mostly analog workflows": 1.00
  },

  // 40
  digitalMaturity: {
    "No PLM or CAD": 0.00,
    "CAD only, manual files": 0.10,
    "Basic PDM": 0.20,
    "PLM in pilot or PoC": 0.30,
    "PLM rolled out": 0.45,
    "Integrated BOM workflows": 0.55,
    "CAD-PLM-ERP partial sync": 0.65,
    "Cross-domain traceability": 0.75,
    "Digital thread active": 0.85,
    "Real-time PLM workflows": 0.93,
    "Autonomous digital ops": 1.00
  },

  // 41
  infraReadiness: {
    "On-premise, outdated infra": 0.00,
    "Limited network access": 0.10,
    "Basic VMs for PLM": 0.20,
    "Shared infra, no PLM scaling": 0.30,
    "PLM scaling bottlenecks": 0.45,
    "Decent infra for hybrid cloud": 0.55,
    "PLM on private cloud": 0.65,
    "Public cloud adoption started": 0.75,
    "Auto-scalable infra enabled": 0.85,
    "Kubernetes PLM ready": 0.93,
    "Full SaaS-native deployment": 1.00
  },

  // 42
  toolFragmentation: {
    "Single system only": 0.00,
    "CAD+Excel": 0.10,
    "PLM + ERP + CAD": 0.20,
    "Multiple homegrown tools": 0.30,
    "No sync between systems": 0.45,
    "Custom integrations exist": 0.55,
    "Partial process overlaps": 0.65,
    "Multi-system conflicts": 0.75,
    "Users toggle between tools": 0.85,
    "Disconnected user experiences": 0.93,
    "High system silos": 1.00
  },

  // 43
  manualExceptions: {
    "No manual exceptions": 0.00,
    "Few exceptions": 0.10,
    "Approval outside PLM": 0.20,
    "BOM edits offline": 0.30,
    "Frequent Excel workarounds": 0.45,
    "No audit of exceptions": 0.55,
    "Exception-heavy workflows": 0.65,
    "Untracked critical changes": 0.75,
    "Significant PLM bypass": 0.85,
    "Governance breakdowns": 0.93,
    "Chaos in critical flows": 1.00
  },

  // 44
  systemAutomation: {
    "Manual flows only": 0.00,
    "Basic email alerts": 0.10,
    "Partial workflow triggers": 0.20,
    "Change-based auto-notifications": 0.30,
    "PLM change propagation active": 0.45,
    "Auto version/release steps": 0.55,
    "System-level conditions applied": 0.65,
    "Auto role routing": 0.75,
    "Intelligent PLM automation": 0.85,
    "AI-suggested process triggers": 0.93,
    "End-to-end orchestration": 1.00
  },

  // 45
  exceptionVolume: {
    "No exceptions": 0.00,
    "1–2/month": 0.10,
    "Weekly": 0.20,
    "Biweekly": 0.30,
    "Daily": 0.45,
    "Multiple/day": 0.55,
    "Frequent cross-team escalations": 0.65,
    "Process bypass common": 0.75,
    "Workarounds dominate": 0.85,
    "Every program hits exceptions": 0.93,
    "Process unusable due to volume": 1.00
  },

  // 46
  testInfrastructure: {
    "No formal test infra": 0.00,
    "Basic test checklist": 0.10,
    "Unit tests in some programs": 0.20,
    "System tests manually tracked": 0.30,
    "Test traceability exists": 0.45,
    "PLM links design to test cases": 0.55,
    "Automated test cycle integrated": 0.65,
    "Test results feed PLM": 0.75,
    "Simulation/test feedback loop": 0.85,
    "Model-based verification in PLM": 0.93,
    "Digital validation platform": 1.00
  },

  // 47
  legacyCustomizationDebt: {
    "Standard PLM usage": 0.00,
    "Few UI tweaks only": 0.10,
    "Deprecated extensions exist": 0.20,
    "Custom scripts in place": 0.30,
    "Multiple custom workflows": 0.45,
    "Hardcoded custom logic": 0.55,
    "Upgrade issues due to custom code": 0.65,
    "Unsupported legacy integrations": 0.75,
    "Shadow systems rely on customizations": 0.85,
    "Multiple custom layers in stack": 0.93,
    "High-risk legacy lock-in": 1.00
  },

  // 48
  digitalThreadContinuity: {
    "No digital thread": 0.00,
    "Basic doc linkage": 0.10,
    "Design → Manufacturing only": 0.20,
    "Trace exists in fragments": 0.30,
    "Release → service trace": 0.45,
    "Req→Design→Test visible": 0.55,
    "Multi-system linkage aligned": 0.65,
    "Real-time thread in pilot": 0.75,
    "Closed-loop feedback active": 0.85,
    "Digital twin linked to PLM": 0.93,
    "Full digital thread deployed": 1.00
  },

  // 49
  skillDiversity: {
    "Only senior PLM users": 0.00,
    "Homogeneous skillset": 0.10,
    "Few tool champions": 0.20,
    "Design-centric users only": 0.30,
    "Part-time contributors vary": 0.45,
    "Cross-domain contributors": 0.55,
    "Program, test, prod included": 0.65,
    "Strong horizontal skill overlap": 0.75,
    "PLM analytics, process, admin": 0.85,
    "Full lifecycle capable teams": 0.93,
    "Self-optimizing user base": 1.00
  },

  // 50
  userBuyIn: {
    "High resistance": 0.00,
    "PLM perceived as overhead": 0.10,
    "Partial support": 0.20,
    "Power users only": 0.30,
    "Training partially effective": 0.45,
    "Adoption slowly growing": 0.55,
    "PLM helps team KPIs": 0.65,
    "Appreciation of value exists": 0.75,
    "Teams drive PLM improvements": 0.85,
    "Internal advocacy active": 0.93,
    "PLM = indispensable tool": 1.00
  },

  // 51
  changeResistance: {
    "Complete refusal": 0.00,
    "High resistance": 0.10,
    "Change fatigue evident": 0.20,
    "Passive resistance": 0.30,
    "Tool adoption slow": 0.45,
    "Some change agents exist": 0.55,
    "Willingness for training": 0.65,
    "Teams request process upgrades": 0.75,
    "Positive momentum for change": 0.85,
    "Proactive change teams": 0.93,
    "PLM as innovation enabler": 1.00
  },
  // 52
  plmTalentAvailability: {
    "No internal PLM talent": 0.00,
    "One part-time admin": 0.10,
    "Basic CAD-admin only": 0.20,
    "Overloaded single SME": 0.30,
    "Support only via vendor": 0.45,
    "1–2 certified PLM experts": 0.55,
    "Internal admin + process owner": 0.65,
    "Cross-functional PLM team": 0.75,
    "Internal trainers available": 0.85,
    "PLM COE functioning": 0.93,
    "Dedicated scalable PLM team": 1.00
  },

  // 53
  integrationDepth: {
    "Standalone PLM": 0.00,
    "CAD only": 0.10,
    "ERP exports via Excel": 0.20,
    "CAD-PLM-ERP manually synced": 0.30,
    "Point-to-point CAD/ERP links": 0.45,
    "PLM–ERP–MES flow enabled": 0.55,
    "Req → Design → Mfg link active": 0.65,
    "Cross-domain, cross-function links": 0.75,
    "BOM change sync across systems": 0.85,
    "Live bi-directional integration": 0.93,
    "Seamless digital enterprise flow": 1.00
  },

  // 54
  cloudOpsDiscipline: {
    "On-prem only": 0.00,
    "Occasional cloud backup": 0.10,
    "Non-prod on cloud": 0.20,
    "Hybrid cloud trials": 0.30,
    "Cloud migration PoC": 0.45,
    "Prod PLM in cloud infra": 0.55,
    "Multi-region PLM hosted": 0.65,
    "Kubernetes PLM ops": 0.75,
    "CloudOps CI/CD flows": 0.85,
    "Immutable PLM deployments": 0.93,
    "Autonomous cloud-native PLM": 1.00
  },

  // 55
  eventDrivenIntegration: {
    "Batch exports only": 0.00,
    "Daily data jobs": 0.10,
    "Scheduled interface scripts": 0.20,
    "Nightly BOM sync": 0.30,
    "Change-based triggers in dev": 0.45,
    "Some pub/sub events handled": 0.55,
    "Change-driven workflows fire": 0.65,
    "Integration events managed": 0.75,
    "Orchestrated system syncs": 0.85,
    "Event brokers in place": 0.93,
    "Real-time event mesh ops": 1.00
  },

  // 56
  digitalTwinConvergence: {
    "No twin model": 0.00,
    "CAD model only": 0.10,
    "3D visualization twin": 0.20,
    "Behavioral twin isolated": 0.30,
    "Connected ops feedback loop": 0.45,
    "Tied to test and service data": 0.55,
    "IoT data into design iteration": 0.65,
    "Twin used in product config": 0.75,
    "Twin influences roadmap": 0.85,
    "Twin drives monetization": 0.93,
    "Twin governs lifecycle value": 1.00
  },

  // 57
  dataLatencyTolerance: {
    "Only real-time accepted": 0.00,
    "Minutes of delay accepted": 0.10,
    "Hourly updates fine": 0.20,
    "Daily sync okay": 0.30,
    "Tolerates stale BOMs": 0.45,
    "ERP lag not critical": 0.55,
    "MES catch-up allowed": 0.65,
    "Delay >1 day tolerated": 0.75,
    "Weekly update tolerance": 0.85,
    "Batch-mode accepted norm": 0.93,
    "Latency doesn’t impact ops": 1.00
  },

  // 58
  ecosystemLicensingStrategy: {
    "No licensing governance": 0.00,
    "Internal license management only": 0.10,
    "Partial user tracking": 0.20,
    "Vendor tool-dependent": 0.30,
    "Per-seat unmanaged": 0.45,
    "Floating license pools": 0.55,
    "Cross-org license tracking": 0.65,
    "Supplier access governed": 0.75,
    "Role-based dynamic assignment": 0.85,
    "Self-service provisioning": 0.93,
    "Federated ecosystem licensing": 1.00
  },

  // 59
  crossPlmInteroperability: {
    "Only one PLM supported": 0.00,
    "Legacy PLM data frozen": 0.10,
    "CAD data not interoperable": 0.20,
    "Manual data porting needed": 0.30,
    "Partially usable JT data": 0.45,
    "Neutral formats exchanged": 0.55,
    "Shared ontology exists": 0.65,
    "Data federated between PLMs": 0.75,
    "Live link to partner PLMs": 0.85,
    "Dynamic federation across PLMs": 0.93,
    "Fully semantic PLM mesh": 1.00
  },

  // 60
  platformEcosystemParticipation: {
    "Isolated system": 0.00,
    "Email-based partner collaboration": 0.10,
    "Cloud portal usage in pilot": 0.20,
    "Some supplier access": 0.30,
    "Point integration with partner tool": 0.45,
    "Open APIs used for collab": 0.55,
    "Linked with supply chain platforms": 0.65,
    "Part of industry cloud platform": 0.75,
    "Contributes to external data mesh": 0.85,
    "Collaborative workflows managed": 0.93,
    "Live digital ecosystem integration": 1.00
  },

  // 61
  speedSensitivity: {
    "No speed pressure": 0.00,
    "Minor dev timeline impact": 0.10,
    "Only final release dates matter": 0.20,
    "Feature delay tolerable": 0.30,
    "Weekly milestones important": 0.45,
    "Late delivery impacts market": 0.55,
    "Competitor launches hurt": 0.65,
    "Regulatory timing critical": 0.75,
    "Customer expectation tight": 0.85,
    "Missing launch is fatal": 0.93,
    "Speed = Strategic weapon": 1.00
  },

  // 62
  competitivePressure: {
    "No market disruption": 0.00,
    "Slow-moving segment": 0.10,
    "Minor innovation race": 0.20,
    "New players emerging": 0.30,
    "Customer shifts visible": 0.45,
    "Direct competitors innovating": 0.55,
    "Faster dev cycle needed": 0.65,
    "Constant cost-pressure exists": 0.75,
    "Tech disruption ongoing": 0.85,
    "Aggressive industry digitization": 0.93,
    "Innovation-to-survive model": 1.00
  },

  // 63
  innovationThroughput: {
    "No innovation focus": 0.00,
    "One product every few years": 0.10,
    "Annual model update": 0.20,
    "Feature releases per quarter": 0.30,
    "Customer-led features grow": 0.45,
    "Bi-monthly launches": 0.55,
    "Frequent test iterations": 0.65,
    "Weekly change proposals": 0.75,
    "Daily configuration updates": 0.85,
    "Continuous innovation delivery": 0.93,
    "Self-adaptive product innovation": 1.00
  },

  // 64
  customerFeedbackLoop: {
    "No feedback captured": 0.00,
    "Ad-hoc surveys": 0.10,
    "Field service inputs shared": 0.20,
    "Basic issue tracking": 0.30,
    "Design-change linked to feedback": 0.45,
    "Feedback tracked in PLM": 0.55,
    "Customer metrics drive changes": 0.65,
    "Test results loop into design": 0.75,
    "Real-time IoT feedback used": 0.85,
    "Automated issue prediction": 0.93,
    "Live feedback in twin workflows": 1.00
  },

  // 65
  timeToValueAcceleration: {
    "No visibility into ROI": 0.00,
    "Payback >3 years": 0.10,
    "2–3 years": 0.20,
    "18–24 months": 0.30,
    "12–18 months": 0.45,
    "9–12 months": 0.55,
    "6–9 months": 0.65,
    "3–6 months": 0.75,
    "Under 3 months": 0.85,
    "Immediate measurable wins": 0.93,
    "Real-time value flow tracked": 1.00
  },

  // 66
  customerCoCreationCapability: {
    "Closed design model": 0.00,
    "Customer suggestion box": 0.10,
    "Ad-hoc co-creation events": 0.20,
    "Input-driven variants allowed": 0.30,
    "Formal customer engagement team": 0.45,
    "Beta testing feedback loop": 0.55,
    "Direct config choices offered": 0.65,
    "Joint design workshops held": 0.75,
    "Co-innovation platforms used": 0.85,
    "Crowd-driven co-creation": 0.93,
    "Real-time participative design": 1.00
  },

  // 67
  regulatoryBurden: {
    "No formal compliance": 0.00,
    "Basic quality checks": 0.10,
    "Manual audit trails": 0.20,
    "Industry stds applied": 0.30,
    "Multinational certs needed": 0.45,
    "Data retention enforced": 0.55,
    "Design-linked regulatory docs": 0.65,
    "Digital records for regulators": 0.75,
    "Auto-tracked cert/test packages": 0.85,
    "Audit-ready compliance workflows": 0.93,
    "Proactive regulatory intelligence": 1.00
  },

  // 68
  recallRisk: {
    "Zero failure environment": 0.00,
    "Minimal post-delivery impact": 0.10,
    "Recalls extremely rare": 0.20,
    "Low-volume recall incidents": 0.30,
    "Known risks in parts": 0.45,
    "Several field issues yearly": 0.55,
    "Costly historical recalls": 0.65,
    "Product lifecycle recall concern": 0.75,
    "Frequent design updates needed": 0.85,
    "Recurring service part changes": 0.93,
    "Recall prevention critical": 1.00
  },
  // 69
  traceabilityNeed: {
    "No traceability": 0.00,
    "Manual Excel mapping": 0.10,
    "Basic Req→Design mapping": 0.20,
    "Partial Design→Test links": 0.30,
    "Initial trace enforcement": 0.45,
    "Lifecycle trace in pilot": 0.55,
    "Req→Design→Test→Release mapped": 0.65,
    "Cross-domain traceability visible": 0.75,
    "End-to-end digital flow": 0.85,
    "Validated trace reports available": 0.93,
    "Regulatory-grade full trace": 1.00
  },

  // 70
  compliancePenalty: {
    "No penalty impact": 0.00,
    "Mild financial risk": 0.10,
    "Single geo-specific risk": 0.20,
    "Known upcoming compliance pressure": 0.30,
    "Fines recorded in history": 0.45,
    "Legal holds managed manually": 0.55,
    "Impactful cost exposure": 0.65,
    "Frequent regulatory updates needed": 0.75,
    "Regulatory gaps detected": 0.85,
    "Compliance failure costs projected": 0.93,
    "High legal risk if unaddressed": 1.00
  },

  // 71
  namingDiscipline: {
    "Free-text naming": 0.00,
    "Loose patterns": 0.10,
    "Manual enforcement only": 0.20,
    "Dept-level conventions": 0.30,
    "Basic object templates": 0.45,
    "Revisioning auto-applied": 0.55,
    "Classification structure present": 0.65,
    "Governed naming + access": 0.75,
    "Context-driven naming enforced": 0.85,
    "Global consistency measured": 0.93,
    "Zero-error naming policies": 1.00
  },

  // 72
  dataGovernanceQuality: {
    "No access control": 0.00,
    "Basic folder-level rights": 0.10,
    "User-based controls": 0.20,
    "Read/write segregation": 0.30,
    "Lifecycle gates present": 0.45,
    "Audit trail and signatures": 0.55,
    "Data owners defined": 0.65,
    "Governance workflows embedded": 0.75,
    "Regulatory-level data control": 0.85,
    "Federated data governance": 0.93,
    "Trustless data flow managed": 1.00
  },

  // 73
  endToEndTraceability: {
    "Trace stops at CAD": 0.00,
    "Design-Test links only": 0.10,
    "CAD–BoM–Change mapped": 0.20,
    "PLM→ERP partially synced": 0.30,
    "Downstream usage visible": 0.45,
    "Req→Design→Validate visible": 0.55,
    "Test + Mfg integrated": 0.65,
    "Trace to service events": 0.75,
    "Live trace across domains": 0.85,
    "Real-time digital twins linked": 0.93,
    "Full lifecycle trace active": 1.00
  },

  // 74
  dataProvenance: {
    "No ownership tracking": 0.00,
    "Created by known team": 0.10,
    "Manual document history": 0.20,
    "Versioning enforced": 0.30,
    "Change logs available": 0.45,
    "Digital signature visible": 0.55,
    "Role trace available": 0.65,
    "Author-chain trace exists": 0.75,
    "System-level provenance": 0.85,
    "AI-explainable data lineage": 0.93,
    "Zero-trust data with audit path": 1.00
  },

  // 75
  regulatoryAuditReadiness: {
    "Not auditable": 0.00,
    "Basic documentation": 0.10,
    "Inconsistent trace": 0.20,
    "Manual signoffs": 0.30,
    "Controlled release flow": 0.45,
    "Partial digital records": 0.55,
    "Change history complete": 0.65,
    "Export-ready traceability": 0.75,
    "Regulatory alignment mapped": 0.85,
    "Real-time audit dashboard": 0.93,
    "Automated audit compliance": 1.00
  },

  // 76
  errorCost: {
    "No known cost": 0.00,
    "Negligible rework": 0.10,
    "Few missed handoffs": 0.20,
    "Delay due to errors": 0.30,
    "BoM errors observed": 0.45,
    "Late change = cost spike": 0.55,
    "Recurring design mistakes": 0.65,
    "High effort due to manual error": 0.75,
    "Process errors affect revenue": 0.85,
    "Cost of error > project margin": 0.93,
    "Error = reputational/financial loss": 1.00
  },

  // 77
  delayPenalty: {
    "No impact from delay": 0.00,
    "Low urgency project": 0.10,
    "Tolerable feature slippage": 0.20,
    "Some timeline overruns": 0.30,
    "Late launch lost revenue": 0.45,
    "Project delay → customer penalty": 0.55,
    "Compliance delay → fine": 0.65,
    "Missed cycle → cost": 0.75,
    "Multi-million loss expected": 0.85,
    "Lost customers from delay": 0.93,
    "Delay = existential risk": 1.00
  },

  // 78
  engineeringCost: {
    "Minimal eng cost": 0.00,
    "Few full-time engineers": 0.10,
    "Mixed tech team (few roles)": 0.20,
    "Standard eng cost burden": 0.30,
    "Rework adds to eng load": 0.45,
    "Change-driven cost ↑": 0.55,
    "Design, test loops expensive": 0.65,
    "Inefficiency drives cost": 0.75,
    "High burn rate for delays": 0.85,
    "Eng cost = key project killer": 0.93,
    "Unsustainable eng overhead": 1.00
  },

  // 79
  reuseLibrary: {
    "No reuse": 0.00,
    "Occasional manual reuse": 0.10,
    "Basic part library": 0.20,
    "Standard parts reused": 0.30,
    "CAD reuse policies exist": 0.45,
    "BoM reuse tracked": 0.55,
    "Subassembly reuse enabled": 0.65,
    "Rule-based reuse enforced": 0.75,
    "Analytics for reuse": 0.85,
    "AI-suggested reuse": 0.93,
    "Smart reuse across enterprise": 1.00
  },

  // 80
  ipRisk: {
    "Fully secure IP": 0.00,
    "Low internal access": 0.10,
    "Manual access logs": 0.20,
    "Occasional leak risk": 0.30,
    "No signed handoffs": 0.45,
    "Export controls missing": 0.55,
    "Critical IP exposed": 0.65,
    "Partner risk known": 0.75,
    "Known incidents in past": 0.85,
    "IP theft → financial loss": 0.93,
    "IP risk = high threat": 1.00
  },

  // 81
  aftermarketFocus: {
    "Only product sales": 0.00,
    "Spare part sales tracked": 0.10,
    "Reactive service model": 0.20,
    "Support revenue noted": 0.30,
    "Basic service BOM exists": 0.45,
    "Preventive service plans": 0.55,
    "Predictive service active": 0.65,
    "Digital twin supports service": 0.75,
    "PLM to service loop exists": 0.85,
    "Service platform monetized": 0.93,
    "Aftermarket = strategic pillar": 1.00
  },

  // 82
  aiReadiness: {
    "No AI infra or intent": 0.00,
    "Some structured data exists": 0.10,
    "Basic dashboards exist": 0.20,
    "Historical data available": 0.30,
    "Preliminary ML attempts": 0.45,
    "Training datasets curated": 0.55,
    "AI use in pilots": 0.65,
    "Models support workflows": 0.75,
    "Operational ML in prod": 0.85,
    "Feedback loops auto-trained": 0.93,
    "AI-first engineering pipeline": 1.00
  },

  // 83
  analyticsCapability: {
    "No analytics tools used": 0.00,
    "Excel/manual reports only": 0.10,
    "Some dashboards": 0.20,
    "Basic change analytics": 0.30,
    "Part cost variance tracked": 0.45,
    "Engineering performance visible": 0.55,
    "Config & reuse analytics": 0.65,
    "Predictive metrics dashboards": 0.75,
    "Causal PLM analytics used": 0.85,
    "Autonomous analytics alerts": 0.93,
    "Self-optimizing decision analytics": 1.00
  },

  // 84
  aiCoDesignAdoption: {
    "No AI used in design": 0.00,
    "Manual variant creation": 0.10,
    "Excel-based logic": 0.20,
    "Visual rule builders": 0.30,
    "AI used in concept stage": 0.45,
    "AI refines existing models": 0.55,
    "Design alternatives generated": 0.65,
    "Simulation-integrated AI": 0.75,
    "Multi-domain AI assistance": 0.85,
    "Autonomous co-design loops": 0.93,
    "AI-led generative engineering": 1.00
  },

  // 85
  intelligentWorkflowOrchestration: {
    "Manual approvals only": 0.00,
    "Basic status flows": 0.10,
    "Workflow builder used": 0.20,
    "Standard automation rules": 0.30,
    "Rule-driven routing": 0.45,
    "Trigger-based automation": 0.55,
    "Conditional multi-step flows": 0.65,
    "AI-influenced paths": 0.75,
    "Real-time adaptive workflows": 0.85,
    "Self-healing process flows": 0.93,
    "Cognitive decision orchestration": 1.00
  }
};
/**
 * Get numeric impact for a factor key and selected label
 * @param {string} factorKey - The key of the factor (e.g. 'sustainabilityPressure')
 * @param {string} label - The slider label (e.g. 'Customer pressure noted')
 * @returns {number} numeric value from 0 to 1
 */
export function getNumericImpact(Key, label) {
  const map = translateVals[Key];
  if (!map) {
    console.warn(`⚠️ Unknown factor key: ${Key}`);
    return 0;
  }

  const value = map[label];
  if (value === undefined) {
    console.warn(`⚠️ Label '${label}' not found in ${Key}`);
    return 0;
  }

  return value;
}